import { axiosInstance } from '@/modules/shared/lib/axios';
import { PayrollSettingsQueryModel } from './types';

type Props = {
  companyId: string
}

export function getPayrollSettings ({ companyId }: Props) {
    return axiosInstance.get<PayrollSettingsQueryModel>(`/api/${companyId}/configuration/payroll`);
}
